import { Grid } from '@nextui-org/react'
// import { Fade } from 'react-awesome-reveal'

import ConnectIcon from '../../../ui/resources/GL_connect.png'
import SupportIcon from '../../../ui/resources/GL_support.png'
import ManageIcon from '../../../ui/resources/GL_manage.png'
import Tile from '../../../ui/tile'
import { Content } from '../../../ui/layout/content'
import HeaderText from '../../../ui/header'

export default ({}) => {
    return (
        <>
            <Content spacerSize={4}>
                {/* <HeaderText h1 centered value="We Strive for Win-Win"/> */}
            </Content>
            {/* <Fade
                fraction={0.3}
                triggerOnce={true}> */}
                <Content>
                    <Grid.Container gap={2}>
                        <Grid xs={12} sm={4}>
                            <Tile 
                                header="We Connect"
                                // bordered={true}
                                icon={ConnectIcon}
                                text="We connect start-ups and academics to initiate collaboration and access grant opportunities. "/>
                        </Grid>
                        <Grid xs={12} sm={4}>
                            <Tile 
                                header="We Support"
                                // bordered={true}
                                icon={SupportIcon}
                                text="We turn a business problem into research topics and actionable requirements."/>
                        </Grid>
                        <Grid xs={12} sm={4}>
                            <Tile 
                                header="We Enable"
                                // bordered={true}
                                icon={ManageIcon}
                                text="We enable interactions between business stakeholders and academics to ensure clarity and transparency in communications."/>
                        </Grid>
                    </Grid.Container>
                </Content>
            {/* </Fade> */}
        </>
    )
}